import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'container',
    'positionName',
    'positionHighlight',
    'positionActive',
    'positionProductName',
    'inventoryID',
    'productList',
    'section'
  ];

  connect() {
    window.addEventListener('positions-loaded', this.onPositionsLoaded);
    window.addEventListener('position-selected', this.handlePositionSelected);
    window.addEventListener('selection-cleared', this.handlePositionCleared);
    window.addEventListener('products-loaded', this.onProductsLoaded);
    window.addEventListener('sections-loaded', this.onSectionsLoaded);
  }

  onProductsLoaded = event => {
    this.products = event.detail.products;
    let productsHTML = '';
    for (let product of this.products) {
      productsHTML += this.renderProduct(product);
    }
    this.productListTarget.innerHTML = productsHTML;
  }

  onPositionsLoaded = event => {
    this.positions = event.detail.positions;
  }

  onSectionsLoaded = event => {
    this.sections = event.detail.sections;
  }

  handlePositionSelected = event => {
    const { position } = event.detail;
    this.position = position;
    this.positionNameTarget.value = position.identifier;
    this.positionHighlightTarget.value = position.highlight;
    this.positionActiveTarget.checked = position.active;
    this.positionProductNameTarget.innerHTML = position.productName;
    this.showPositionSettings();
    this.populateSectionOptions();
    this.renderInventoryLink();
  }

  handlePositionCleared = () => {
    this.hidePositionSettings();
  }

  handleLabelChanged(event) {
    this.position.setLabel(event.target.value);
  }

  handleHighlightChanged(event) {
    this.position.setHighlight(event.target.value);
  }

  handleActivenessChanged() {
    this.position.setActiveness(this.positionActiveTarget.checked);
  }

  hidePositionSettings() {
    this.containerTarget.classList.add('hidden');
  }

  showPositionSettings() {
    this.containerTarget.classList.remove('hidden');
  }

  populateSectionOptions() {
    this.sectionTarget.innerHTML = null;
    this.sectionTarget.add(new Option('None', null, true));
    this.sections.forEach(section => {
      let selected = section.id === this.position.sectionId;
      this.sectionTarget.add(new Option(section.identifier, section.id, false, selected));
    });
  }

  renderInventoryLink() {
    let inventoryUnitId = this.position.inventoryUnitId
    let inventoryLink = `<a href="/sandbar/admin/inventory_units/${inventoryUnitId}" target="_blank">${inventoryUnitId}</a>`;
    this.inventoryIDTarget.innerHTML = inventoryLink
  }

  renderProduct(product) {
    return `
      <li class='mb-4 border-b cursor-pointer relative opacity-75 cursor-not-allowed'
        id='product-${product.id}'
        data-id='${product.id}'
        <span data-id='${product.id}' class='text-md block mb-1'>${product.name}</span>
        <span data-id='${product.id}' class='text-xs text-gray-500 stats'>
          ${product.totalPlacedInventories} of ${product.totalAvailableInventories} placed
        </span>
      </li>
    `;
  }

}
